import React from 'react';
import { PaymentSource } from '../../constants';
import { useOrderDetailsPaymentSource } from '../OrderDetailsPaymentSources';
import { OrderDetailsAmazonShippingAndPayment } from '../AmazonShippingAndPayment';
import { OrderDetailsPayPalShippingAndPayment } from '../PayPalShippingAndPayment';
import { OrderDetailsShippingAddress } from '../ShippingAddress';
import { OrderDetailsShippingMethod } from './OrderDetailsShippingMethod';
import { OrderDetailsPaymentSection } from './OrderDetailsPaymentSection';
import { OrderDetailsItemsSections } from './OrderDetailsItemsSections';
import { OrderDetailsSiteCreditAndRewards } from './OrderDetailsSiteCreditsAndRewards';

export const OrderDetailsMain: React.FC = () => {
  const { paymentSource } = useOrderDetailsPaymentSource();

  return (
    <>
      {(paymentSource === PaymentSource.Adyen ||
        paymentSource === PaymentSource.Affirm ||
        paymentSource === PaymentSource.Apple) && (
        <>
          <OrderDetailsShippingAddress />
          <OrderDetailsShippingMethod />
          <OrderDetailsPaymentSection />
        </>
      )}
      {paymentSource === PaymentSource.Amazon && (
        <>
          <OrderDetailsAmazonShippingAndPayment />
          <OrderDetailsShippingMethod />
        </>
      )}
      {paymentSource === PaymentSource.PayPal && (
        <>
          <OrderDetailsPayPalShippingAndPayment />
          <OrderDetailsShippingMethod />
        </>
      )}

      <OrderDetailsSiteCreditAndRewards />

      <OrderDetailsItemsSections />
    </>
  );
};
